/* eslint-disable @typescript-eslint/no-explicit-any */
import { MutationHookOptions, useMutation } from '@apollo/client';
import { graphql } from '../gql';
import {
  UpsertSubmissionMutation,
  UpsertSubmissionMutationVariables,
} from '../gql/graphql';
import { GET_QUOTES } from './quotes.query';
import { GET_SUBMISSION } from './submission.query';

export function useUpsertSubmissionMutation(
  options: MutationHookOptions<
    UpsertSubmissionMutation,
    UpsertSubmissionMutationVariables
  > = {},
  refetchQuery?: 'Overview' | 'SubmissionQueue',
  awaitRefetch = true
) {
  const refetchQueries: any[] = [GET_QUOTES, GET_SUBMISSION];

  const [upsertSubmission, { loading, error, reset, data }] = useMutation(
    graphql(`
      mutation upsertSubmission($details: SubmissionInput!) {
        upsertSubmission(details: $details) {
          ... on Submission {
            uuid
            referenceId
            type
            status
          }
          ... on EntityAlreadyExists {
            message
            confirmationToken
            code
          }
          ... on ValidationErrors {
            message
            code
            errors {
              code
              field
              message
            }
          }
        }
      }
    `),
    {
      ...options,
      refetchQueries: refetchQueries,
      awaitRefetchQueries: awaitRefetch,
    }
  );

  return {
    upsertSubmission,
    loading,
    error,
    reset,
    data,
  };
}
